import React from 'react';
import clsx from 'clsx';
import { Text, TextMarkup } from '../../text';
import { Link } from '../../link';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Timeline Content Component
 * @param children {ReactNode} Use it if you want custom children for content
 * @param className {string} Additionnal CSS Classes
 * @param content {string} Text content
 * @param contentLink {string} Text for content link
 * @param heading {string} Text heading
 * @param link {string} Url link
 * @param Onclick {string} Provide event onCLick
 */
const TimelineContent = ({ children, className, heading, content, link, contentLink, onClick, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('timeline-content', className));
    if (children) {
        return (React.createElement("div", { className: classes, ...others }, children));
    }
    return (React.createElement("div", { className: classes, ...others, onClick: (e) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e.stopPropagation();
        } },
        heading && (React.createElement(Text, { className: 'heading', markup: TextMarkup.P }, heading)),
        content && (React.createElement(Text, { className: 'main-content', markup: TextMarkup.P }, content)),
        link && React.createElement(Link, { href: link }, contentLink || link)));
};
export default TimelineContent;
//# sourceMappingURL=TimelineContent.js.map